export default __webpack_public_path__ + "static/single-event-place-holder-image-4cc6ef33ed0ed0d3e263b9a6a0997a11.jpg";